import { render } from "./TalentProfileView.vue?vue&type=template&id=235032de"
import script from "./TalentProfileView.vue?vue&type=script&lang=js"
export * from "./TalentProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__